import React, { useContext } from 'react';
import { MyContext } from '@/config/context-manager';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Apple from '@/components/Icon/Apple';
import cls from 'classnames';
import GoogleIcon from '@public/images/common/google.svg';
import type { HoverQrType } from '../../data';

interface IPCButton {
  type: HoverQrType;
  onClick?(): void;
  showQR?: boolean;
  onHoverQr?(visible: boolean): void;
}
const PCButton: React.FC<IPCButton> = ({ type, onClick, showQR, onHoverQr }) => {
  const { locale } = useContext(MyContext);
  const { t } = useTranslation('download');
  return (
    <>
      <div
        className="relative flex cursor-pointer items-center justify-start rounded-2xl bg-black px-2 py-5 text-white lg:h-[64px] xl:h-[88px] xl:px-3"
        onClick={onClick}
      >
        {type === 'Apple' ? (
          <Apple
            className={cls(
              locale === 'en' ? 'lg:h-8 lg:w-8 xl:h-12 xl:w-12' : 'lg:h-[18px] lg:w-[18px] xl:h-8 xl:w-8',
              'mr-2 xl:mr-3',
            )}
            fill="white"
          />
        ) : (
          <Image
            className={cls(
              locale === 'en'
                ? 'relative mr-2 lg:h-8 lg:w-8 xl:h-12 xl:w-12'
                : 'relative mr-1 lg:h-[18px] lg:w-[18px] xl:h-8 xl:w-8',
              'xl:mr-3',
            )}
            alt="google play"
            width={40}
            height={40}
            src={GoogleIcon}
            quality={100}
          />
        )}
        <div
          className={cls(
            locale === 'en'
              ? 'flex-col text-xs xl:text-[14px] [&>strong]:text-[20px] xl:[&>strong]:text-[26px]'
              : 'items-center justify-center text-[14px] xl:text-[20px] [&>strong]:text-[16px] xl:[&>strong]:text-[20px]',
            'flex leading-normal [&>strong]:mr-1 [&>strong]:tracking-normal [&>strong]:xl:mr-2',
          )}
          dangerouslySetInnerHTML={{ __html: type === 'Apple' ? t('App Store 下载') : t('Google Play 下载') }}
        />
        {showQR && (
          <div
            className="absolute right-0 top-0 h-15 w-15 rounded-tr-[14px] bg-[url('/images/download/QRbg-lg.png')] bg-cover text-white xl:bg-[url('/images/download/QRbg-xl.png')]"
            onMouseEnter={() => onHoverQr?.(true)}
            onMouseLeave={() => onHoverQr?.(false)}
          />
        )}
      </div>
    </>
  );
};

export default PCButton;
